import React from "react";
import { motion } from "framer-motion";

const Skeleton = ({
  size = "md",
  variant = "",
  animation = "wave",
  lines = 3,
}) => {
  const getSize = () => {
    switch (variant) {
      case "text":
        return (
          {
            xs: "h-2",
            "xs-sm": "h-3",
            sm: "h-4",
            md: "h-5",
            lg: "h-6",
            xl: "h-7",
          }[size] || "h-5"
        );

      case "circle":
        return (
          {
            xs: "h-5 w-5",
            "xs-sm": "h-6 w-6",
            sm: "h-7 w-7",
            md: "h-8 w-8",
            lg: "h-9 w-9",
            xl: "h-10 w-10",
          }[size] || "h-8 w-8"
        );

      case "rectangle":
        return (
          {
            xs: "h-5",
            "xs-sm": "h-6",
            sm: "h-7",
            md: "h-8",
            lg: "h-9",
            xl: "h-10",
          }[size] || "h-8"
        );

      case "image":
        return (
          {
            xs: "h-20",
            "xs-sm": "h-24",
            sm: "h-28",
            md: "h-32",
            lg: "h-36",
            xl: "h-40",
          }[size] || "h-32"
        );

      default:
        return "h-5";
    }
  };

  const getVariant = () => {
    switch (variant) {
      case "circle":
        return "rounded-full";
      case "image":
        return "rounded-lg";
      default:
        return "rounded";
    }
  };

  const getAnimationProps = () => {
    if (animation === false) return {};

    if (animation === "wave") {
      return {
        initial: { backgroundPosition: "200% 0" },
        animate: { backgroundPosition: "-200% 0" },
        transition: {
          repeat: Infinity,
          duration: 3,
          ease: "linear",
        },
        style: {
          backgroundImage:
            "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)",
          backgroundSize: "200% 100%",
        },
      };
    }

    return {
      animate: { opacity: [0.5, 1, 0.5] },
      transition: {
        repeat: Infinity,
        duration: 2,
        ease: "linear",
      },
    };
  };

  if (variant === "paragraph") {
    return (
      <div className="flex flex-col gap-2">
        {[...Array(lines)].map((_, index) => (
          <motion.div
            key={index}
            className={`bg-gray-200 rounded ${
              index === lines - 1 ? "w-3/4" : "w-full"
            } h-4`}
            {...getAnimationProps()}
          />
        ))}
      </div>
    );
  }
  if (variant === "image") {
    return (
      <motion.div
        className={`bg-gray-200 ${getSize()} ${getVariant()} ${
          variant !== "circle" ? "w-full" : ""
        } relative flex items-center justify-center`}
        {...getAnimationProps()}
      >
        <span className={`material-symbols-rounded text-gray-400 text-3xl`}>
          image
        </span>
      </motion.div>
    );
  }

  return (
    <motion.div
      className={`bg-gray-200 ${getSize()} ${getVariant()} ${
        variant !== "circle" ? "w-full" : ""
      }`}
      {...getAnimationProps()}
    />
  );
};

export default Skeleton;
